import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { Layout, NavDrawer, Panel, Sidebar } from 'react-toolbox/lib/layout'
import { Element } from 'react-scroll'
import T from 'i18n-react'

import {
  PARTNER_SITE_SELECTION,
} from 'containers/Admin/PartnerSite/PartnerSiteSelection/constants'
import {
  ADMIN_PARTER_SITE
} from './constants'

import partnerSiteSelectionSagas from 'containers/Admin/PartnerSite/PartnerSiteSelection/sagas'
import partnerSiteSagas from './sagas'

import Heading from './Heading'
import CSSModules from 'helpers/CSSModulesUtil'
import injectSagas from 'helpers/injectSagas'
import MainPanel from './MainPanel'

import Link from './Link'
import List from './List'
import styles from './styles.scss'

import {
  mount,
  unmount
} from './actions'

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    mount: () => dispatch(mount()),
    unmount: () => dispatch(unmount())
  }
}

class AdminPartnerSitePage extends Component {
  componentWillMount() {
    this.props.mount()
  }

  componentWillUnmount() {
    this.props.unmount()
  }

  render() {
    return (
      <Layout theme={styles}>
        <NavDrawer pinned scrollY theme={styles}>
          <Heading>
            Navigation
          </Heading>
          <List>
            <Link
              label={T.translate('containers.admin.partnerSite.index.title')}
              containerId='scrollContainer'
              to='Partner Site Roles'
            />
            <Link
              label={"Manage Product Family Support Team"}
              containerId='scrollContainer'
              to='Partner Site Product Family Roles'
            />
          </List>
        </NavDrawer>
        <Panel theme={styles}>
          <MainPanel/>
        </Panel>
      </Layout>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(styles)
const withPartnerSiteSelectionSaga = injectSagas({ [PARTNER_SITE_SELECTION]: partnerSiteSelectionSagas })
const withPartnerSiteSaga = injectSagas({ [ADMIN_PARTER_SITE]: partnerSiteSagas })
const enhance = compose(
  withConnect,
  withPartnerSiteSelectionSaga,
  withPartnerSiteSaga,
  withStyles
)

export default enhance(AdminPartnerSitePage)
